import React from 'react';
import { NavLink } from 'react-router-dom';

export const AdminBreadcrumb = ({ children }) => {
    return (
        <nav aria-label="breadcrumb">
            <div className="breadcrumb">
                <NavLink className="breadcrumb-item text-decoration-none" to="/">
                    Home
                </NavLink>
                <NavLink className="breadcrumb-item text-decoration-none" to="/admin">
                    Dashboard
                </NavLink>
                {children}
            </div>
        </nav>
    );
};
